import React, { useCallback, useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import BuyButton from '@wix/da-ds/pkg/Buttons/BuyButton';
import { BiData } from '@wix/da-bi/pkg/events';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import { pushAdoptsSellerModal } from '../../../Modals/redux/actionCreators';
import { getIsAdoptableFixedPriceType, getIsAdoptableOfferType, getIsOnSale, getIsPending, getPrice } from '../../../utils/adoptables';
import { ElementVisibility, ElementVisibilityContext } from '../../ElementVisibilityContext';
import s from './AdoptableSeller.scss';
export const AdoptableSeller = ({ deviation, className })=>{
    var _adoptableSellerElementVisibility, _adoptableSellerElementVisibility1;
    const { elementGroups: { adoptableSeller: adoptableSellerElementVisibility } } = useContext(ElementVisibilityContext);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const openEditModal = useCallback(()=>{
        dispatch(pushAdoptsSellerModal(deviation, 'update'));
    }, [
        deviation,
        dispatch
    ]);
    const openOfferModal = useCallback(()=>{
        dispatch(pushAdoptsSellerModal(deviation, 'offers'));
    }, [
        deviation,
        dispatch
    ]);
    const isPending = getIsPending(deviation);
    const isOnSale = getIsOnSale(deviation);
    // FEATURE_CLEANUP: adoptables_resale we can remove this check since the action bar's element visibility code
    // will handle it
    if (!isOnSale && !isPending) {
        return null;
    }
    const isOfferType = getIsAdoptableOfferType(deviation);
    const isFixedPriceType = getIsAdoptableFixedPriceType(deviation);
    const price = getPrice(deviation);
    return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        className: className,
        popoverWrapperClassName: s['wrapper']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['status']
    }, isOfferType && !isFixedPriceType && /*#__PURE__*/ React.createElement("span", null, t('actionbar.adoptables.openToOffers')), !isOfferType && isFixedPriceType && /*#__PURE__*/ React.createElement("span", null, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: 'actionbar.adoptables.adoptForPrice'
    }, "Adopt for $", {
        price
    })), isOfferType && isFixedPriceType && /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: 'actionbar.adoptables.adoptForPrice'
    }, "Adopt for $", {
        price
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['subscript']
    }, t('actionbar.adoptables.subtitle')))), /*#__PURE__*/ React.createElement("div", {
        className: s['buttons']
    }, ((_adoptableSellerElementVisibility = adoptableSellerElementVisibility) === null || _adoptableSellerElementVisibility === void 0 ? void 0 : _adoptableSellerElementVisibility.editSale) === ElementVisibility.Bar && /*#__PURE__*/ React.createElement(BuyButton, {
        variant: 'outline',
        size: 'medium',
        rounded: true,
        onClick: openEditModal,
        className: s['button'],
        biData: BiData({
            evid: 742,
            itemid: deviation.deviationId,
            typeid: deviation.typeId,
            sectionname: 'action_bar'
        })
    }, t('actionbar.adoptables.editSale')), ((_adoptableSellerElementVisibility1 = adoptableSellerElementVisibility) === null || _adoptableSellerElementVisibility1 === void 0 ? void 0 : _adoptableSellerElementVisibility1.viewOffers) === ElementVisibility.Bar && /*#__PURE__*/ React.createElement(BuyButton, {
        variant: 'outline',
        size: 'medium',
        rounded: true,
        onClick: openOfferModal,
        className: s['button'],
        biData: BiData({
            evid: 746,
            itemid: deviation.deviationId,
            typeid: deviation.typeId,
            sectionname: 'action_bar'
        })
    }, t('actionbar.adoptables.viewOffers'))));
};
AdoptableSeller.displayName = 'AdoptableSeller';
export default AdoptableSeller;
